import { render, staticRenderFns } from "./GeradorDocumento.vue?vue&type=template&id=9bb836e6"
import script from "./GeradorDocumento.vue?vue&type=script&lang=js"
export * from "./GeradorDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports